"use client";

import { TolgeeProvider } from "@tolgee/react";
import type { TolgeeStaticData } from "@tolgee/react";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { TolgeeBase } from "./shared";

const tolgee = TolgeeBase().init();

type TolgeeNextProviderProps = {
  language: string;
  staticData: TolgeeStaticData;
  children: React.ReactNode;
};

export const TolgeeNextProvider = ({
  language,
  staticData,
  children,
}: TolgeeNextProviderProps) => {
  const router = useRouter();

  useEffect(() => {
    const { unsubscribe } = tolgee.on("permanentChange", () => {
      router.refresh();
    });

    return () => unsubscribe();
  }, [router]);

  return (
    <TolgeeProvider
      tolgee={tolgee}
      // Пока Tolgee не ответил, показываем приложение на статических переводах, а не спиннер
      // во весь экран: сервер переводов может быть недоступен или отвечать долго, и тогда
      // пользователь смотрел на крутилку вместо работающего интерфейса.
      fallback={children}
      options={{ useSuspense: false }}
      ssr={{ language, staticData }}
    >
      {children}
    </TolgeeProvider>
  );
};
